import { PaymentClient, Transaction } from "../../types/transaction";
import { generateAPI } from "../api.generator";


export const buyLovewallSubscriptionPlan = generateAPI<
  {
    body: {
      lwspID: string;
      paymentClient: PaymentClient;
    }
  },
  Transaction
>("post", "subscriptions/plan/lovewall/buy");
